import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User, UserPost } from './cliente-editar-usuario.model';

const BASE_PATH = environment.basePath;
const headers = new HttpHeaders({ "Content-Type": "application/json" });

@Injectable({
    providedIn: 'root'
})

export class MasterClienteEditarUsuarioService {

    constructor(private http: HttpClient) { }

    getUserById(payload: string): Observable<User> {
        return this.http.post<User>(`${BASE_PATH}/bff/users/findById`, payload, { headers: headers });
    }

    inactivateUser(id: number, user: User, reason: string): Observable<User> {
        return this.http.put(`${BASE_PATH}/bff/master/edit-user/user?statusOnly=true`,
            {
                id: id,
                status: "Inativo",
                reason: reason,
                name: user.name,
                nationality: user.nationality,
                login: user.login
            },
            { headers: headers });
    } v

    //updateUser(payload: any): Observable<User> {
    //    return this.http.put(`${BASE_PATH}/bff/master/edit-user/user/`, payload, { headers: headers });
    //}

    listStatus(): Observable<any[]> {
        return this.http.get<any[]>(`${BASE_PATH}/bff/screen/edit-user/user/status`);
    }

    updateUser(user: UserPost) {
        return this.http.put(`${BASE_PATH}/bff/users`, user)
            .toPromise()
    }

    updateMasterUser(user: User) {
        return this.http.put(`${BASE_PATH}/bff/users`, user)
            .toPromise()
    }
}